<div class="section-header" mat-dialog-title>
    <mat-icon class="section-icon">folder_open</mat-icon>
    <span class="section-title">{{ 'ai.selectCategoryCreate' | transloco }}</span>
    <button mat-icon-button class="close-button" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<div mat-dialog-content>

    <div class="tree-content">
        <mat-tree [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl" class="static-tree-wrapper mat-tree-position">
        <mat-tree-node *matTreeNodeDef="let node">
            <li class="mat-tree-node" (click)="onNodeSelected(node)" [ngStyle]="{'color': (clickSelection.isSelected(node) || selectedTreePath == node.TreePath) ? markTreeSelection : null}">
                <button mat-icon-button disabled></button>
                {{node.Name}}
                <app-add-node (addedNode)="addChildNode($event)" [isTop]="false" [currentNode]="node"></app-add-node>
            </li>
        </mat-tree-node>
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
            <li >
                <div class="mat-tree-node" (click)="onNodeSelected(node)" [ngStyle]="{'color': (clickSelection.isSelected(node) || selectedTreePath == node.TreePath) ? markTreeSelection : null}">
                    <button mat-icon-button matTreeNodeToggle
                            [attr.aria-label]="'toggle ' + node.Name">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{nestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                    </button>
                    {{node.Name}}
                    <app-add-node (addedNode)="addChildNode($event)" [isTop]="false" [currentNode]="node"></app-add-node>
                </div>
                <ul [class.tree-wrapper-invisible]="!nestedTreeControl.isExpanded(node)">
                    <ng-container matTreeNodeOutlet></ng-container>
                </ul>
            </li>
        </mat-nested-tree-node>
        </mat-tree>
    </div>
</div>
